import Box from '@mui/material/Box';
import Button, { ButtonProps } from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

interface ConditionalButtonProps extends ButtonProps {
  disabledReason: string;
}

const ConditionalButton = ({ disabledReason, ...buttonProps }: ConditionalButtonProps) => {
  if (buttonProps.disabled) {
    return (
      <Tooltip title={disabledReason}>
        <Box><Button {...buttonProps} /></Box>
      </Tooltip>
    );
  }

  return <Button {...buttonProps} />;
};

export default ConditionalButton;
